// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/electronica-2018/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const electronica2018DE: PageEntry = {
  id: "post.electronica-2018",
  locale: "de",
  slug: "electronica-2018",
  seo: {
    title: "electronica 2018 | Dietz GmbH",
    description: "electronica 2018",
  },
  type: "post",
  h1: "electronica 2018",
  blocks: [
    { kind: "heading", level: 2, text: "electronica 2018" },
    { kind: "paragraph", text: "Welche Komponenten, Systeme oder Anwendungen, neue Entwicklungen wie Smart Home oder Connected Car erst möglich machen, zeigt sich zuallererst auf der Weltleitmesse electronica. Wir waren dabei und blicken zurück auf vier tolle Messetage in München. Wir möchten uns nochmals bei allen Besuchern unseres Messestandes recht herzlich für Ihr Interesse bedanken." }
  ],
};
